<template>
  <div
    class="presentation"
    :class="{
      'white': $store.state.slide.textColour == '#ffffff',
      'slide-text-left': $store.state.slide.textAlign == 'left',
      'slide-text-right': $store.state.slide.textAlign == 'right',
      'slide-text-center': $store.state.slide.textAlign == 'center',
      'enable-audio-control': $store.state.slide.audioAudienceShowControl,
      'waiting-for-next-slide': dataSlideNext && dataSlideNext.id,
    }"
  >
    <Tabs />
    <SlideProgressBar
      v-if="$store.state.presentation.id && !isSortSlide"
      :class="{'invisible': $store.state.presentation.privateMode}"
    />
    <LostConnection
      v-if="$store.state.socketDisconnect || $store.state.connectionError"
    />
    <div
      class="confirm-next-slide"
      :class="{active: showConfirmNext}"
      v-if="$store.state.slide.id && !$store.state.presentation.audiencePacing"
    >
      <div class="text">
        {{ $t("popupNextSlide") }}
      </div>
      <div>
        <ui-button size="sm" @click="confirmNextSlide" class="border-primary">
          {{ $t("goToSlideButton") }}
        </ui-button>
        <ui-button size="sm" variant="outline-primary" @click="cancelNext">
          {{ $t("cancelButton") }}
        </ui-button>
      </div>
    </div>
    <div class="loading-screen horizontal layout center center-justified" v-if="isLoading">
      <Loading />
    </div>

    <div class="tabs-content">
      <div v-if="$store.state.activeTabView === 'slide'">
        <Logo />
        <div v-if="!$store.state.presentation.privateMode">
          <div
            class="content-presentation"
            v-if="!isLoading && !limitOnline"
            :class="{'is-content-slide': $store.state.slide.type === 'freestyle'}"
          >
            <div
              v-if="isLoadNextSlide"
              class="text-center padding horizontal layout center center-justified loading-slide-data"
            >
              <Loading />
            </div>

            <AudienceAdmissionForm v-if="enableAudienceAdmissionForm()" />

            <div v-if="!enableAudienceAdmissionForm()">
              <div v-if="!$store.state.slide.isEndSlide">
                <MultipleChoiceContent
                  v-if="$store.state.slide.type == 'multipleChoice'
                    || $store.state.slide.type == 'imageChoice'
                    || $store.state.slide.type == 'scale'"
                />
                <QuestionContent v-if="$store.state.slide.type == 'question'" />
                <OpenEndedContent v-if="$store.state.slide.type == 'openEnded'" />
                <IdeasContent v-if="$store.state.slide.id && $store.state.slide.type === 'ideas'" />

                <TextSlideContent
                  v-if="$store.state.slide.id && $store.state.slide.type == 'textSlide'"
                />
                <TextSlideContent
                  v-if="$store.state.slide.id && $store.state.slide.type == 'bulletPoints'"
                />
                <FreestyleContent v-if="slide.id && slide.type == 'freestyle'" />
                <QRCodeContent v-if="$store.state.slide.id && $store.state.slide.type == 'qrcode'" />
                <ImageContent v-if="$store.state.slide.id && $store.state.slide.type == 'image'" />
                <ImageContent v-if="$store.state.slide.id && $store.state.slide.type == 'document'" />
                <YoutubeContent v-if="$store.state.slide.id && $store.state.slide.type == 'youtube'" />
                <GoogleSlidesContent
                  v-if="$store.state.slide.id && $store.state.slide.type == 'googleSlides'"
                />
                <WordCloudContent
                  v-if="$store.state.slide.id && $store.state.slide.type == 'wordCloud'"
                />

                <PickAnswerContent
                  v-if="$store.state.slide.id && $store.state.slide.type == 'pickAnswer'"
                />

                <LeaderboardContent
                  v-if="
                    $store.state.slide.id
                      && $store.state.slide.type == 'leaderboard'
                      && !$store.state.presentation.teamPlay
                  "
                />
                <LeaderboardTeamContent
                  v-if="
                    $store.state.slide.id
                      && $store.state.slide.type == 'leaderboard'
                      && $store.state.presentation.teamPlay
                  "
                />
                <SpinnerWheelContent
                  v-if="$store.state.slide.id && $store.state.slide.type == 'spinnerWheel'"
                />

                <QASessionBtn v-if="_checkShowQASessionBtn()" id="presentation-qna-global" />
                <div
                  class="audience-pacing"
                  v-if="
                    $store.state.slide.id
                      && $store.state.presentation.audiencePacing
                      && showAudiencePacingBtn
                  "
                >
                  <ui-button
                    block
                    size="lg"
                    variant="outline-dark"
                    v-if="!checkLastSlide() && checkTextSkip()"
                    @click="audienceChangeSlide()"
                  >
                    {{ $t("skipButton") }}
                  </ui-button>
                  <ui-button
                    block
                    size="lg"
                    variant="outline-dark"
                    v-if="!checkLastSlide() && isShowNextButton()"
                    @click="audienceChangeSlide()"
                  >
                    <span>{{ $t("nextButton") }}</span>
                    <i class="fas fa-angle-double-right" />
                  </ui-button>
                  <ui-button
                    block
                    size="lg"
                    variant="outline-dark"
                    v-if="checkLastSlide()"
                    @click="endPresentation()"
                  >
                    {{ $t("finishButton") }}
                  </ui-button>
                </div>
              </div>
              <LastSlide v-if="$store.state.slide.isEndSlide" />

              <div v-if="$store.state.showQaSession" class="box-qna-session">
                <div class="overlay-qna" @click="hideQASession" />
                <QASession />
              </div>

              <div
                v-if="$store.state.showRequestPresentation"
                class="box-request-presentation vertical layout"
              >
                <div class="overlay-qna" @click="hideRequestPresentation" />
                <div class="flex" />
                <RequestPresentationForm />
              </div>
            </div>

            <AudienceAuthentication v-if="enableAudienceAuthentication" />
          </div>
          <div class="text-center content-presentation padding" v-if="limitOnline">
            <h3>Participant limit exceeded</h3>
            <p>{{ limitOnline }}</p>
          </div>
        </div>

        <div class="text-center padding" v-else>
          {{ $t("presentationIsNotOpen") }}
          <div class="try-to-reload">
            {{ $t("Or try to") }}
            <a
              class="link-reload"
              @click="reloadPage()"
              :class="{'white': $store.state.slide.textColour == '#ffffff'}"
            >
              {{ $t("reloadTextLink") }}
            </a>
          </div>
        </div>
      </div>
      <div v-if="$store.state.activeTabView === 'feedback'">
        <FeedbackForm />
      </div>
    </div>

    <VoiceCallAlert
      v-if="$store.state.voiceCall.isOpen && $store.state.voiceCall.status === 'waiting-accept'"
    />
    <VoiceCallView
      v-if="$store.state.voiceCall.isOpen && $store.state.voiceCall.status === 'during-call'"
    />
  </div>
</template>

<script>
// @ is an alias to /src
import _ from 'lodash'
import { setTimeout } from 'timers'
import * as Sentry from '@sentry/vue'
import { mapState, mapActions } from 'vuex'
import Config from '@/config'
import Util from '@/util'
import Loading from '@/components/Loading'
import Logo from '@/components/Logo'
import MultipleChoiceContent from '@/components/types/MutipleChoiceContent'
import OpenEndedContent from '@/components/types/OpenEndedContent'
import TextSlideContent from '@/components/types/TextSlideContent'
import FreestyleContent from '@/components/types/FreestyleContent'
import QRCodeContent from '@/components/types/QRCodeContent'
import ImageContent from '@/components/types/ImageContent'
import YoutubeContent from '@/components/types/YoutubeContent'
import GoogleSlidesContent from '@/components/types/GoogleSlidesContent'
import WordCloudContent from '@/components/types/WordCloudContent'
import PickAnswerContent from '@/components/types/PickAnswerContent'
import QASession from '@/components/QASession'
import FeedbackForm from '@/components/FeedbackForm'
import RequestPresentationForm from '@/components/footer/RequestPresentationForm'
import QASessionBtn from '@/components/QASessionBtn'
import SlideProgressBar from '@/components/SlideProgressBar'
import LeaderboardContent from '@/components/types/LeaderboardContent'
import LeaderboardTeamContent from '@/components/types/LeaderboardTeamContent'
import QuestionContent from '@/components/types/QuestionContent'
import LostConnection from '@/components/LostConnection'
import storage from '@/services/storage'
import LastSlide from '@/components/LastSlide.vue'
import LastSlideContainer from '@/containers/last-slide/LastSlide'
import SpinnerWheelContent from '@/components/types/SpinnerWheelContent.vue'
import SpinnerWheelContainer from '@/containers/spinner-wheel/SpinnerWheel'
import IdeasContent from '@/components/types/IdeasContent.vue'
import AudienceAdmissionForm from '@/components/AudienceAdmissionForm.vue'
import VoiceCallAlert from '@/components/voice-call/VoiceCallAlert.vue'
import VoiceCallView from '@/components/voice-call/VoiceCallView.vue'
import AudienceAuthentication from '@/components/audienceAuthentication/AudienceAuthentication.vue'
import Tabs from '@/components/Tabs.vue'

// UI
import UiButton from '@/components/UI/Button'

import socket from '@/socket'
import EventBus from '@/eventBus'
import QuizStatuses from '@/constants/QuizStatuses'
import SelfPacedQuiz from '@/services/SelfPacedQuiz'

// classes
import Audience from '@/classes/audience'
import audienceApi from '@/api/audience'

// 3rd parties
import sentry from '@/3rd-parties/sentry'

export default {
  name: 'Presentation',
  components: {
    LastSlide: LastSlideContainer(LastSlide),
    SpinnerWheelContent: SpinnerWheelContainer(SpinnerWheelContent),
    AudienceAdmissionForm,
    Loading,
    Logo,
    UiButton,
    MultipleChoiceContent,
    OpenEndedContent,
    TextSlideContent,
    FreestyleContent,
    QRCodeContent,
    ImageContent,
    YoutubeContent,
    GoogleSlidesContent,
    WordCloudContent,
    PickAnswerContent,
    LeaderboardContent,
    QASession,
    QASessionBtn,
    QuestionContent,
    SlideProgressBar,
    LostConnection,
    LeaderboardTeamContent,
    IdeasContent,
    RequestPresentationForm,
    VoiceCallAlert,
    VoiceCallView,
    AudienceAuthentication,
    FeedbackForm,
    Tabs,
  },
  data() {
    return {
      uniqueAccessCode: '',
      isLoading: true,
      dataSlideNext: null,
      showConfirmNext: false,
      isConnectSocket: false,
      isLoadNextSlide: false,
      presenterUrl: '',
      limitOnline: '',
      isSortSlide: false,
      currentDataBulletPoint: null,
    }
  },
  computed: {
    ...mapState({
      audienceId: (state) => state.audienceId,
      audienceEmail: (state) => state.audienceEmail,
      authenticationCode: (state) => state.authenticationCode,
      presentation: (state) => state.presentation,
      slide: (state) => state.slide,
      currentDataNextSlide: (state) => state.currentDataNextSlide,
    }),

    showAudiencePacingBtn() {
      const { type } = this.slide
      if (type === 'multipleChoice' || type === 'imageChoice') {
        return false
      }
      return true
    },
    enableAudienceAuthentication() {
      const { isAudienceAuthentication } = this.presentation
      if (isAudienceAuthentication && !this.authenticationCode) {
        return true
      }
      return false
    },
  },
  mounted() {
    window.addEventListener('popstate', this.popStateHandler)

    let pathAccesscode = false
    if (this.$route.name === 'presenterAccessCode') {
      pathAccesscode = true
    }
    this.presenterUrl = Config.presenterUrl
    this.uniqueAccessCode = this.$route.params.id
    this.getPresentation(pathAccesscode)
    EventBus.$on('confirmNextSlide', (id) => {
      if (id) {
        this.dataSlideNext = {}
        this.dataSlideNext.id = id
      }

      if (
        this.dataSlideNext
        && this.dataSlideNext.id
        && this.dataSlideNext.id !== this.$store.state.slide.id
      ) {
        this.confirmNextSlide()
      } else {
        SelfPacedQuiz.playSelfPacedQuizSlide(this.presentation, this.slide)
      }
    })

    EventBus.$on('skipSlide', () => {
      this.audienceChangeSlide()
    })

    EventBus.$on('hidePopupNextSlide', (isClearNextSlide) => {
      this.showConfirmNext = false
      if (isClearNextSlide) {
        this.dataSlideNext = {}
      }
    })

    try {
      // FIXME: Consider removing this as there should be any
      // reason why we need a specific class for safari.
      // This was added by Loi to fix an issue with safari
      // but we lost track of the original issue. @huongnguyen2152 15.05.2020
      // eslint-disable-next-line
      let isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));
      const ua = window.navigator.userAgent
      const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i)
      const webkit = !!ua.match(/WebKit/i)
      const iOSSafari = iOS && webkit && !ua.match(/CriOS/i)
      if (isSafari || iOSSafari) {
        document.body.classList.add('safari-browser')
      }
    } catch (error) {
      // do notthing
    }
  },
  destroy() {
    socket.unSubscribe(this.uniqueAccessCode.toLowerCase())
    socket.close()
    EventBus.$off('confirmNextSlide')
    EventBus.$off('skipSlide')
    EventBus.$off('hidePopupNextSlide')
    window.removeEventListener('popstate', this.popStateHandler)
  },
  methods: {
    ...mapActions(['setAudienceIdAction', 'patchPresentationAction']),
    ...mapActions('presentationChat', ['clearChatMessagesAction']),
    popStateHandler() {
      this.audienceChangeSlide(true)
    },
    enableAudienceAdmissionForm() {
      return Util.enableAudienceAdmissionForm()
    },
    reloadPage() {
      window.location.reload()
    },
    showqna() {
      this.$store.state.showQaSession = true
      Util.gaTrackEvent(
        'Question And Answer',
        'Audience',
        'Open Ask a question popup',
      )
    },
    _checkShowQASessionBtn() {
      const { slide } = this.$store.state
      if (
        slide.type !== 'leaderboard' &&
        slide.type !== 'pickAnswer' &&
        (this.$store.state.presentation.qnaAllSlide ||
          slide.type === 'question') &&
        !this.isLoadNextSlide &&
        (!slide.multipleChoiceStatus ||
          (slide.multipleChoiceStatus && slide.multipleChoiceStatus !== 3))
      ) {
        return true
      }
      return false
    },
    checkTextSkip() {
      if (
        this.$store.state.slide.type === 'wordCloud' ||
        this.$store.state.slide.type === 'multipleChoice' ||
        this.$store.state.slide.type === 'openEnded' ||
        this.$store.state.slide.type === 'imageChoice' ||
        this.$store.state.slide.type === 'ideas'
      ) {
        return true
      }
      if (this.$store.state.slide.type === 'pickAnswer') {
        return false
      }

      return false
    },
    isShowNextButton() {
      // Keep the old Next button for current slide types, except the Quiz (type == 'pickAnswer') and Leaderboard
      return !this.checkTextSkip() && this.slide.type !== 'pickAnswer' && this.slide.type !== 'leaderboard'
    },
    endPresentation() {
      this.$store.state.slide.isEndSlide = true
      this.$store.dispatch('updateSlide', this.$store.state.slide)
    },
    checkLastSlide() {
      if (this.presentation.audiencePacing && this.slide.type === 'pickAnswer') {
        return false
      }

      const index = this.$store.state.slides.findIndex((item) => {
        return item.id === this.$store.state.slide.id
      })

      if (index !== -1 && index === this.$store.state.slides.length - 1) {
        return true
      }

      return false
    },
    checkAudiencePacing() {
      this.$store.state.slide.isEndSlide = false
      const currentSlideIndex = Util.getCurrentSlideIndexFromUrl()

      if (typeof currentSlideIndex === 'number' &&
        this.$store.state.slides.length &&
        this.$store.state.presentation &&
        this.$store.state.presentation.audiencePacing
      ) {
        if (currentSlideIndex < this.$store.state.slides.length) {
          this.$store.state.idSlide = this.$store.state.slides[currentSlideIndex].id
          this.confirmNextSlide()
        } else {
          const path = `${window.location.pathname}#1`
          window.history.pushState({}, 'Live Audience Engagement Platform - AhaSlides', path)
          this.$store.state.idSlide = this.$store.state.slides[0].id
          this.confirmNextSlide()
        }
      }
    },
    audienceChangeSlide(isFromPopState) {
      if (!this.$store.state.slides.length) return
      const currentSlideIndex = this.$store.state.slides.findIndex((item) => {
        return item.id === this.$store.state.slide.id
      })

      let nextIndexFromStateChange
      let isPrev
      if (isFromPopState) { // clicking either back or forward btn or changing hash directly
        nextIndexFromStateChange = Util.getCurrentSlideIndexFromUrl()
        if (nextIndexFromStateChange === currentSlideIndex
        || nextIndexFromStateChange > this.$store.state.slides.length - 1) return
        isPrev = nextIndexFromStateChange < currentSlideIndex
      } else { // by clicking the next button
        isPrev = false
      }

      if (currentSlideIndex !== -1) {
        if (currentSlideIndex === 0 && isPrev) return
        const shouldPushState = !isFromPopState && !isPrev
        let idSlide // next Slide to fetch data for

        if (!isPrev) { // switching to next slide
          if (currentSlideIndex !== this.$store.state.slides.length - 1) {
            const indexToGo = isFromPopState ? nextIndexFromStateChange : currentSlideIndex + 1
            idSlide = this.$store.state.slides[indexToGo].id
            this.moveToNextSlide(idSlide, indexToGo, isPrev, shouldPushState)
          } else {
            this.$store.state.slide.isEndSlide = true
          }
        } else if (isPrev) {
          if (currentSlideIndex !== 0) {
            const indexToGo = isFromPopState ? nextIndexFromStateChange : currentSlideIndex - 1
            idSlide = this.$store.state.slides[indexToGo].id
            this.moveToNextSlide(idSlide, indexToGo, isPrev, shouldPushState)
          }
        }
      }
    },

    moveToNextSlide(idSlide, nextSlideIndex, isPrev, shouldPushState) {
      this.$store.state.idSlide = idSlide
      this.confirmNextSlide()
      const path = `${window.location.pathname}#${nextSlideIndex + 1}`

      if (!isPrev) {
        if (shouldPushState) window.history.pushState({}, 'Live Audience Engagement Platform - AhaSlides', path)
        Util.gaTrackEvent('Audience', 'Audience Pacing > Next Slide', this.uniqueAccessCode, idSlide)
      } else {
        Util.gaTrackEvent('Audience', 'Audience Pacing > Previous Slide', this.uniqueAccessCode, idSlide)
      }
    },

    confirmNextSlide() {
      // should maintain the text colour of the last slide
      // in order to show the correct logo loader
      const emptySlide = {
        id: null,
        textColour: this.$store.state.slide.textColour,
      }
      if (this.currentDataNextSlide) {
        emptySlide.timestamp = this.currentDataNextSlide.timestamp
      }
      this.isLoadNextSlide = true
      this.$store.dispatch('setSlide', emptySlide)

      if (
        this.$store.state.presentation.audiencePacing &&
        this.$store.state.idSlide
      ) {
        this.dataSlideNext = {
          id: this.$store.state.idSlide,
        }
      }
      if (!this.dataSlideNext) return
      const idNextSlide = this.dataSlideNext.id
      const _handleGetSlideData = () => {
        this.$http
          .get(Config.api.getNextSlide + idNextSlide)
          .then(
            (res) => {
              if (emptySlide.timestamp && this.currentDataNextSlide && emptySlide.timestamp < this.currentDataNextSlide.timestamp) {
                return
              }
              this.isLoadNextSlide = false
              res.body = Util.formatSlide(res.body)
              this.$store.dispatch('setSlide', res.body)
              SelfPacedQuiz.playSelfPacedQuizSlide(this.presentation, res.body)
              this.showConfirmNext = false
              this.dataSlideNext = null
            },
            () => {
              this.isLoadNextSlide = false
            },
          )
      }

      // Only get from cache when presenting and presenter-pacing and having slideCacheUrl
      if (this.dataSlideNext.slideCacheUrl && this.$store.state.presentation.presenting && !this.$store.state.presentation.audiencePacing) {
        const url = this.dataSlideNext.slideCacheUrl
        this.$http.get(url)
          .then((res) => {
            if (emptySlide.timestamp && this.currentDataNextSlide && emptySlide.timestamp < this.currentDataNextSlide.timestamp) {
              return
            }
            res.body = this.tryParseBody(res.bodyText, this.$store.state.presentation.id)
            this.isLoadNextSlide = false
            res.body = Util.formatSlide(res.body)
            this.$store.dispatch('setSlide', res.body)
            this.showConfirmNext = false
            this.dataSlideNext = null
          })
          .catch((err) => {
            _handleGetSlideData()
            if (Sentry && err.status) {
              err.from = 'Audience get next slide'
              Sentry.captureException(JSON.stringify(err))
            }
          })
      } else {
        _handleGetSlideData()
      }

      this.dataSlideNext = null
      this.showConfirmNext = false
    },

    cancelNext() {
      this.showConfirmNext = false
    },
    async getPresentation(pathAccesscode) {
      const params = {
        connect: true,
      }
      if (pathAccesscode) {
        params.pathAccesscode = pathAccesscode
      }
      if (this.$store.state.idSlide) {
        params.idSlide = this.$store.state.idSlide
      }

      let dataPresentation = null
      try {
        dataPresentation = await this.$http.get(
          Config.api.getPresentationFromCdn + this.uniqueAccessCode,
          { params },
        )
      } catch (error) {
        this.isLoading = false
        this.$router.push({
          name: 'home',
          query: { error: true },
        })

        return
      }

      let presentationId = null
      if (dataPresentation.body.presentation && dataPresentation.body.presentation.id) {
        presentationId = dataPresentation.body.presentation.id
      } else {
        presentationId = dataPresentation.body.id
      }

      this.handleResetData(dataPresentation.body)

      const audienceId = storage.getValueByPresentation(presentationId, 'audienceId', Audience.generateId())
      const audienceName = storage.getValueByPresentation(presentationId, 'audienceName', '')
      const audienceEmail = storage.getValueByPresentation(presentationId, 'audienceEmail', '')
      const audienceTeam = storage.getValueByPresentation(presentationId, 'audienceTeam', '')
      const authenticationCode = storage.getValueByPresentation(presentationId, 'authenticationCode', '')
      // make sure audienceId is set to the state
      await this.setAudienceIdAction(audienceId)
      this.$store.state.audienceName = audienceName
      this.$store.state.audienceEmail = audienceEmail
      this.$store.state.audienceTeam = audienceTeam
      this.$store.state.authenticationCode = authenticationCode

      // get audienceEmoji
      let audienceEmoji = storage.getValueByPresentation(presentationId, 'audienceEmoji')
      if (audienceEmoji) {
        this.$store.state.isAudienceEmojiDisabled = true
      } else {
        audienceEmoji = Util.getRandomEmoji()
      }

      this.$store.state.audienceEmoji = audienceEmoji

      if (dataPresentation.body.presentation) {
        this._hanldeAudienceGetPresentation(dataPresentation, pathAccesscode)
        return
      }

      const urlCdn = dataPresentation.body.cacheSlideActiveUrl

      try {
        const res = await this.$http.get(urlCdn)
        res.body = this.tryParseBody(res.bodyText, presentationId)
        res.body.presentation = dataPresentation.body
        this._hanldeAudienceGetPresentation(res, pathAccesscode)
        return
      } catch (error) {
        if (Sentry && error.status) {
          error.from = 'Audience get presentation'
          Sentry.captureException(JSON.stringify(error))
        }
      }

      const dataUnhandle = await this.$http.get(
        Config.api.getPresentation + this.uniqueAccessCode,
        { params },
      )

      this._hanldeAudienceGetPresentation(dataUnhandle, pathAccesscode)
    },

    tryParseBody(text, presentationId) {
      // This function to fix AHA-116
      // TODO: Remove this sometime later
      const rawText = Util.decrypt(text, presentationId)
      try {
        return JSON.parse(rawText)
      } catch (SyntaxError) {
        return JSON.parse(decodeURIComponent(rawText))
      }
    },
    handleInitSocket(res) {
      this.handleDataQuestions(res.body.presentation)

      if (this.isConnectSocket) {
        // eslint-disable-next-line promise/catch-or-return
        this.$http
          .get(Config.api.getPresentationFromCdn + this.uniqueAccessCode)
          .then((dataPresentation) => {
            if (!dataPresentation.body.presenting) {
              this._handleDataReconnect(dataPresentation)
              return
            }

            if (!dataPresentation.body.slideActiveCacheUrl) {
              return
            }

            const urlCdn = dataPresentation.body.slideActiveCacheUrl

            // eslint-disable-next-line promise/no-nesting
            this.$http.get(urlCdn)
              .then((res) => {
                res.body = this.tryParseBody(res.bodyText, dataPresentation.body.id)
                res.body.presentation = dataPresentation.body
                this._handleDataReconnect(res)
              })
              .catch((err) => {
                // eslint-disable-next-line promise/catch-or-return
                this.$http.get(Config.api.getPresentation + this.uniqueAccessCode)
                  .then((dataUnhandle) => {
                    this._handleDataReconnect(dataUnhandle)
                  })

                if (Sentry && err.status) {
                  err.from = 'Audience reconnect'
                  Sentry.captureException(JSON.stringify(err))
                }
              })
          }, (err) => {
            if (err.status === 400) {
              this.$router.push({
                name: 'home',
                query: { error: true },
              })
            }
          })

        this.$store.state.socketDisconnect = false
        Util.gaTrackEvent(
          'System Status',
          'Connection is back',
          this.$store.state.presentation.id,
          { nonInteraction: true },
        )

        return
      }
      socket.subscribe(this.uniqueAccessCode.toLowerCase(), (message) => {
        this.handleSocketData(message)
      })

      this.isConnectSocket = true
      const self = this
      socket.getSocket().on('disconnect', () => {
        self.$store.state.socketDisconnect = true
        Util.gaTrackEvent(
          'System Status',
          'Notify poor connection',
          self.$store.state.presentation.id,
          { nonInteraction: true },
        )
      })
    },
    handleCreateReaction: _.throttle(function (data) {
      EventBus.$emit('reaction-animation', data)
      if (this.presentation.numberOfHearts < data.numberOfHearts) {
        this.patchPresentationAction({
          numberOfHearts: data.numberOfHearts,
        })
      }
      if (this.presentation.numberOfLikes < data.numberOfLikes) {
        this.patchPresentationAction({
          numberOfLikes: data.numberOfLikes,
        })
      }
      if (this.presentation.numberOfLaughs < data.numberOfLaughs) {
        this.patchPresentationAction({
          numberOfLaughs: data.numberOfLaughs,
        })
      }
      if (this.presentation.numberOfSads < data.numberOfSads) {
        this.patchPresentationAction({
          numberOfSads: data.numberOfSads,
        })
      }
      if (this.presentation.numberOfWows < data.numberOfWows) {
        this.patchPresentationAction({
          numberOfWows: data.numberOfWows,
        })
      }
    }, 300),
    _hanldeAudienceGetPresentation(res, pathAccesscode) {
      if (res.body.limitOnline) {
        if (res.body.message) {
          this.limitOnline = res.body.message
        } else {
          this.limitOnline =
            'This presentation has reached the max capacity allowed. To join in, please ask your presenter to upgrade their account to a bigger plan.'
        }
        this.isLoading = false
        return
      }

      res.body = Util.formatSlide(res.body)
      this._clearDataSlide(res.body)

      if (res.body.presentation.audiencePacing) {
        this.getSlideList(res.body.presentation.id)
      } else {
        window.history.replaceState(null, null, ' ')
        setTimeout(() => {
          this.isLoading = false
        }, 500)
      }
      this.$store.dispatch('setPresentation', res.body.presentation)
      this.$store.dispatch('setSlide', res.body)

      if (!res.body.presentation) {
        res.body.presentation = {}
      } else if (
        this.uniqueAccessCode !== res.body.presentation.uniqueAccessCode ||
        pathAccesscode
      ) {
        this.$router.replace({
          name: 'Presentation',
          query: this.$route.query,
          params: { id: res.body.presentation.uniqueAccessCode },
        })
      }

      this.uniqueAccessCode = res.body.presentation.uniqueAccessCode

      if (res.body.presentation && !res.body.presentation.language) {
        res.body.presentation.language = 'en'
      }
      this.$store.dispatch('setLang', res.body.presentation.language)
      if (
        res.body.presentation.fontFamily &&
        res.body.presentation.fontFamily != 'nunito'
      ) {
        Util.setFontSlide(res.body.presentation.fontFamily)
      }
      this.$store.state.logo = res.body.presentation.logo

      socket.init(() => this.handleInitSocket(res), this.uniqueAccessCode.toLowerCase(), this.audienceId)
      socket.on('patch-presentation', this.patchPresentationAction)
      socket.on('create-reaction', this.handleCreateReaction)
      socket.on('patch-slide-options', this.handleSlideOption)

      // get audienceQuizTeam
      const audienceQuizTeam = storage.getValueByPresentation(this.$store.state.presentation.id, 'audienceQuizTeam')
      if (audienceQuizTeam) {
        if (this.$store.state.presentation.teamPlay) {
          const index = this.$store.state.presentation.teamData.filter((item) => {
            return item.id === audienceQuizTeam && item.visible
          })
          if (index !== -1) {
            this.$store.state.audienceQuizTeam = audienceQuizTeam
          }
        }
      }

      if (res.body.presentation && !res.body.presentation.privateMode && this.audienceId) {
        // Chỉ ghi nhận participant nếu presentation ở PUBLIC mode
        this.trackAudienceJoinPresentation(this.audienceId, res.body.presentation.id)
      }
      this.checkAudienceAuthentication()
    },

    async checkAudienceAuthentication() {
      setTimeout(async () => {
        const { planType, isAudienceAuthentication } = this.presentation
        if (isAudienceAuthentication && this.authenticationCode && (planType === 'pro-yearly' || planType === 'pro-monthly' || planType === 'one-time-large' || planType === 'white-label')) {
          try {
            await this.$http.post(Config.api.audienceCheckAuthentication, {
              uniqueAccessCode: this.presentation.uniqueAccessCode,
              authenticationCode: this.authenticationCode,
              audienceId: this.audienceId,
            })
          } catch {
            this.$store.state.authenticationCode = ''
            storage.setValueByPresentation(
              this.presentation.id,
              'authenticationCode',
              '',
            )
          }
        }
      }, 1000)
    },

    trackAudienceJoinPresentation(audienceId, presentationId) {
      audienceApi.createAudience({
        audienceId,
        presentationId,
      })
      storage.updateValueByPresentation(presentationId, 'audienceId', audienceId)
    },
    async _handleDataReconnect(res) {
      const { quizStatus } = this.$store.state.slide
      res.body = Util.formatSlide(res.body)
      if (res.body.limitOnline || res.body.presentation.audiencePacing) {
        window.location.reload()
        return
      }
      if (res.body.id == this.$store.state.slide.id) {
        // DEBUG AHA-6742
        try {
          if (res.body.slideTimestamp < this.$store.state.slide.slideTimestamp) {
            Sentry.captureException(new Error('DEBUG AHA-6742: Returned slide is older than current'))
          }

          if (res.body.quizTimestamp.length == 0 && this.$store.state.slide.quizTimestamp > 0) {
            Sentry.captureException(new Error('DEBUG AHA-6742: quizTimestamp was removed'))
          }
        } catch (err) {
          Sentry.captureException(err)
        }
        // END OF DEBUG
        const self = this
        const _compareData = function () {
          let count = 0
          for (let i = 0; i < res.body.SlideOptions.length; i++) {
            for (
              let j = 0;
              j < self.$store.state.slide.SlideOptions.length;
              j++
            ) {
              if (
                self.$store.state.slide.SlideOptions[j].id ==
                res.body.SlideOptions[i].id
              ) {
                res.body.SlideOptions[i].selected =
                  self.$store.state.slide.SlideOptions[j].selected
                res.body.SlideOptions[i].disable =
                  self.$store.state.slide.SlideOptions[j].disable

                if (res.body.SlideOptions[i].selected) {
                  count++
                }
                if (count > res.body.limitChoice) {
                  res.body.SlideOptions[i].selected = false
                  res.body.SlideOptions[i].disable = true
                } else {
                  res.body.SlideOptions[i].disable = false
                }
                break
              }
            }
          }
          res.body.radioSelectded = self.$store.state.slide.radioSelectded
          return res.body
        }
        if (
          this.$store.state.slide.id == res.body.id
          && this.$store.state.slide.type === 'pickAnswer'
          && quizStatus < 4
          && res.body.quizStatus == QuizStatuses.QUESTION_SCREEN
          && res.body.quizTimestamp
          && res.body.quizTimestamp.length
        ) {
          this.$store.state.countdownTimeToAnswer = res.body.timeToAnswer
          this.$store.state.slide.quizTimestamp = res.body.quizTimestamp
          EventBus.$emit('start-countdown-pick-answer')
        }
        this.$store.dispatch('setSlide', _compareData())
      } else {
        this.dataSlideNext = res.body
        this.confirmNextSlide()
      }

      if (
        this.$store.state.slide.type === 'spinnerWheel' || this.$store.state.slide.type === 'qrcode'
        || (this.$store.state.slide.type === 'pickAnswer' && this.$store.state.slide.quizStatus == QuizStatuses.LOBBY_SCREEN)
      ) {
        const data = {
          a: this.audienceId,
          c: this.$store.state.presentation.uniqueAccessCode,
          n: this.$store.state.audienceName,
          e: this.$store.state.audienceEmoji,
          t: this.$store.state.audienceQuizTeam,
        }

        try {
          await this.$http.post(Config.api.joinPresentation, data)
        } catch {
          // do nothing
        }
      }
    },

    async decryptSlide(doc, slideId) {
      try {
        return this.tryParseBody(doc.data, doc.socketId)
      } catch (error) {
        sentry.captureException('Cannot decrypt socket slide data', { extra: { doc } })
      }

      try {
        const res = await this.$http.get(Config.api.getNextSlide + slideId)
        return Util.formatSlide(res.body)
      } catch {
        // do nothing
      }

      return {}
    },

    handleResetData(doc) {
      if (!doc) {
        return
      }
      let presentation = doc
      if (doc.presentation) {
        presentation = doc.presentation
      }

      if (!presentation.resetTimeStamp) {
        return
      }

      const {
        id: presentationId,
        resetTimeStamp: newResetTimeStamp,
      } = presentation

      try {
        const oldResetTimeStamp = storage.getValueByPresentation(presentationId, 'resetTimeStamp')

        if (oldResetTimeStamp !== newResetTimeStamp) {
          storage.clearValueByPresentation(presentationId)
          storage.setValueByPresentation(presentationId, 'resetTimeStamp', newResetTimeStamp)
        }
      } catch (error) {
        // do nothing
      }
    },

    async handleSocketData(doc) {
      if (doc.type === 'account-removal') {
        this.$router.push({
          name: 'home',
          query: { error: true },
        })
        return
      }
      const _getIndex = (arr, id) => {
        return arr.findIndex((item) => {
          return id == item.id
        })
      }

      const { slide } = this.$store.state
      if (doc.type === 'slideOption') {
        if (slide.id != doc.data.slideId) return
        let shouldSort = false
        if (doc.action === 'update') {
          const indexOption = _getIndex(slide.SlideOptions, doc.data.id)
          if (indexOption != -1) {
            slide.SlideOptions[indexOption].title = doc.data.title
            slide.SlideOptions[indexOption].order = doc.data.order
            slide.SlideOptions[indexOption].correct = doc.data.correct
            slide.SlideOptions[indexOption].image = doc.data.image
            slide.SlideOptions[indexOption].pairTitle = doc.data.pairTitle
            slide.SlideOptions[indexOption].imageCropped = doc.data.imageCropped
          }
          shouldSort = true
        } else if (doc.action === 'create') {
          slide.SlideOptions.push(doc.data)
          shouldSort = true
        } else if (doc.action === 'delete') {
          const indexOption = _getIndex(slide.SlideOptions, doc.data.id)
          if (indexOption != -1) {
            slide.SlideOptions.splice(indexOption, 1)
          }
          if (slide.radioSelectded == doc.data.id) {
            slide.radioSelectded = null
          }
        } else if (doc.action === 'sort') {
          const { updatedSlideOption } = doc.data

          slide.SlideOptions.forEach((item) => {
            if (item.id === updatedSlideOption.id) {
              item.order = updatedSlideOption.order
            }
          })

          shouldSort = true
        }

        if (shouldSort) {
          slide.SlideOptions.sort((a, b) => a.order - b.order)
        }
      } else if (doc.type === 'slide') {
        if (doc.isEncrypted) {
          doc.data = await this.decryptSlide(doc, slide.id)
        }

        if (slide.id !== doc.data.id) return
        if (
          !doc.data.multipleChoice &&
          doc.data.multipleChoice != slide.multipleChoice
        ) {
          for (let i = 0; i < slide.SlideOptions.length; i++) {
            if (slide.SlideOptions[i].selected) {
              slide.radioSelectded = slide.SlideOptions[i].id
              break
            }
          }
        }
        if (slide.limitChoice != doc.data.limitChoice) {
          let count = 0
          for (let i = 0; i < slide.SlideOptions.length; i++) {
            if (slide.SlideOptions[i].selected) {
              count++
            }

            if (count > doc.data.limitChoice) {
              slide.SlideOptions[i].selected = false
              slide.SlideOptions[i].disabled = true
            } else {
              slide.SlideOptions[i].disabled = false
            }
          }
        }
        slide.title = doc.data.title
        slide.titleHTML = doc.data.titleHTML
        slide.bodyHTML = doc.data.bodyHTML
        slide.titleDesc = doc.data.titleDesc
        slide.deleted = doc.data.deleted
        slide.openEndedMultipleOption = doc.data.openEndedMultipleOption
        slide.multipleChoice = doc.data.multipleChoice
        slide.stopSubmission = doc.data.stopSubmission
        slide.subheading = doc.data.subheading
        slide.bulletPointsIndex = doc.data.bulletPointsIndex
        slide.showAllBulletPoints = doc.data.showAllBulletPoints
        slide.imageCaption = doc.data.imageCaption
        slide.imageType = doc.data.imageType
        slide.slideType = doc.data.slideType
        slide.textAlign = doc.data.textAlign
        slide.otherCorrectQuiz = doc.data.otherCorrectQuiz
        slide.correctQuizTypeAnswer = doc.data.correctQuizTypeAnswer
        slide.audioName = doc.data.audioName
        slide.audioShowControl = doc.data.audioShowControl
        slide.audioAutoPlay = doc.data.audioAutoPlay
        slide.audioRepeat = doc.data.audioRepeat
        slide.audioPlayOnAudience = doc.data.audioPlayOnAudience
        slide.audioAudienceShowControl = doc.data.audioAudienceShowControl
        slide.minPoint = doc.data.minPoint
        slide.maxPoint = doc.data.maxPoint
        slide.showIframe = doc.data.showIframe
        slide.showYouTubeIframe = doc.data.showYouTubeIframe
        slide.isCorrectGetPoint = doc.data.isCorrectGetPoint
        slide.metadata = doc.data.metadata
        slide.showVotingResultsOnAudience = doc.data.showVotingResultsOnAudience
        slide.showPercentage = doc.data.showPercentage
        slide.imageSubmission = doc.data.imageSubmission

        if (slide.textColour != doc.data.textColour) {
          document.body.style.color = doc.data.textColour
          slide.textColour = doc.data.textColour
        }

        if (slide.baseColour != doc.data.baseColour) {
          slide.baseColour = doc.data.baseColour
          document.body.style.backgroundColor = doc.data.baseColour
        }
        if (document.getElementById('qna-session-box')) {
          document.getElementById('qna-session-box').style.backgroundColor =
            slide.baseColour
          document.getElementById('qna-session-box').style.color =
            slide.textColour
        }

        slide.publishedLink = doc.data.publishedLink
        slide.youtubeLink = doc.data.youtubeLink
        slide.visibility = doc.data.visibility
        slide.timeToAnswer = doc.data.timeToAnswer
        slide.fastAnswerGetMorePoint = doc.data.fastAnswerGetMorePoint
        slide.questionIndex = doc.data.questionIndex
        slide.questionCount = doc.data.questionCount
        slide.voteStep = doc.data.voteStep
        slide.hideResult = doc.data.hideResult
        slide.showCorrectOption = doc.data.showCorrectOption
        slide.scale = doc.data.scale
        slide.hasTimeLimit = doc.data.hasTimeLimit
        slide.randomColours = doc.data.randomColours

        sentry.addBreadcrumb({
          level: 'info',
          message: 'Socket message with type "slide"',
          data: {
            data: doc.data,
            quizTimestamp: doc.data.quizTimestamp,
          },
        })

        if (!this.presentation.audiencePacing) {
          if (doc.data.quizTimestamp) {
            slide.quizTimestamp = doc.data.quizTimestamp
          }

          slide.quizStatus = doc.data.quizStatus
        }

        // TODO: Remote fastestAnswerCache
        if (slide.fastestAnswerCache !== doc.data.fastestAnswerCache) {
          slide.fastestAnswerCache = doc.data.fastestAnswerCache
        }

        if (slide.quizResultCache !== doc.data.quizResultCache) {
          slide.quizResultCache = doc.data.quizResultCache
        }

        let dispatchSlideUpdate = false

        if (slide.stopSubmissionTime !== doc.data.stopSubmissionTime) {
          slide.stopSubmissionTime = doc.data.stopSubmissionTime
          dispatchSlideUpdate = true
        }

        if (slide.entriesPerParticipant != doc.data.entriesPerParticipant) {
          slide.entriesPerParticipant = doc.data.entriesPerParticipant
          dispatchSlideUpdate = true
        }

        if (!doc.data.additionalFields) {
          slide.additionalFields = []
        }

        if (!doc.data.otherCorrectQuiz) {
          slide.otherCorrectQuiz = []
        }

        try {
          slide.additionalFields = JSON.parse(doc.data.additionalFields)
        } catch (error) {
          slide.additionalFields = []
        }

        try {
          slide.otherCorrectQuiz = JSON.parse(doc.data.otherCorrectQuiz)
        } catch (error) {
          slide.otherCorrectQuiz = []
        }

        if (slide.type === 'pickAnswer' && !this.$store.state.presentation.audiencePacing) {
          slide.limitChoice = this.$store.state.slide.SlideOptions.length

          if (doc.data.quizStatus == QuizStatuses.COUNTDOWN_5S_SCREEN) {
            EventBus.$emit('startQuizScreenTwo')
          }

          if (doc.data.quizStatus == QuizStatuses.RESULT_SCREEN) {
            EventBus.$emit('quizTimeout')
            EventBus.$emit('stop-progress-bar-quiz')
          }

          if (
            !this.$store.state.presentation.presenting &&
            doc.data.quizStatus > 1
          ) {
            this.$store.state.presentation.presenting = true
          }
        } else {
          slide.limitChoice = doc.data.limitChoice
        }

        if (slide.image !== doc.data.image) {
          if (!doc.data.image) {
            slide.image = null
          } else if (!slide.image || (slide.image.name !== doc.data.image.name)) {
            slide.image = doc.data.image
          }
          dispatchSlideUpdate = true
        }

        if (slide.backgroundImage !== doc.data.backgroundImage) {
          if (!doc.data.backgroundImage) {
            slide.backgroundImage = null
          } else if (
            !slide.backgroundImage
            || slide.backgroundImage.name !== doc.data.backgroundImage.name
          ) {
            slide.backgroundImage = doc.data.backgroundImage
          }
          dispatchSlideUpdate = true
        }

        // single point for dispatch update slide
        if (dispatchSlideUpdate) {
          this.$store.dispatch('updateSlide', slide)
        }

        if (slide.type != doc.data.type) {
          this.dataSlideNext = {
            presentation: {
              accessCode: this.$store.state.presentation.uniqueAccessCode,
            },
            id: slide.id,
          }
          this.confirmNextSlide()
        }
      } else if (doc.type === 'presentation') {
        if (doc.action === 'nextSlide') {
          if (slide.id && this.$store.state.presentation.audiencePacing) {
            return
          }
          this.$store.state.idSlide = null
          if (doc.data.id == this.$store.state.slide.id) {
            if (doc.data.reload) {
              this.$router.go()
            } else {
              this.showConfirmNext = false
              this.dataSlideNext = null
            }
            return
          }
          if (this.currentDataNextSlide && this.currentDataNextSlide.timestamp > doc.data.timestamp) {
            return
          }
          this.$store.state.currentDataNextSlide = doc.data
          this.dataSlideNext = doc.data

          if (this.$store.state.slide.id === null) {
            this.confirmNextSlide()
          }

          if (
            this.$store.state.slide.type === 'textSlide' ||
            this.$store.state.slide.type === 'bulletPoints' ||
            this.$store.state.slide.type === 'freestyle' ||
            this.$store.state.slide.type === 'qrcode' ||
            this.$store.state.slide.type === 'image' ||
            this.$store.state.slide.type === 'youtube' ||
            this.$store.state.slide.type === 'question' ||
            this.$store.state.slide.type === 'document' ||
            this.$store.state.slide.type === 'googleSlides' ||
            this.$store.state.presentation.privateMode ||
            this.enableAudienceAdmissionForm()
          ) {
            this.confirmNextSlide()
            return
          }

          if (
            doc.data.type === 'pickAnswer' ||
            this.$store.state.slide.type === 'pickAnswer' ||
            doc.data.type === 'spinnerWheel' ||
            this.$store.state.slide.type === 'spinnerWheel' ||
            doc.data.type === 'ideas' ||
            this.$store.state.slide.type === 'ideas'
          ) {
            this.confirmNextSlide()
            this.dataSlideNext = null
            this.showConfirmNext = false
            return
          }

          if (this.$store.state.slide.type === 'leaderboard') {
            if (
              !this.$store.state.audienceName ||
              this.$store.state.slide.finalLeaderboard
            ) {
              this.showConfirmNext = true
              return
            }
            this.confirmNextSlide()
            return
          }

          // When submission is stopped, go to next slide immediately
          if (this.$store.state.slide.stopSubmission &&
            [
              'openEnded',
              'wordCloud',
              'multipleChoice',
              'imageChoice',
              'scale',
            ].indexOf(this.$store.state.slide.type) > -1
          ) {
            this.showConfirmNext = false
            this.confirmNextSlide()
            return
          }

          if (
            this.$store.state.slide.type === 'openEnded' &&
            this.$store.state.slide.openEndedSubmited &&
            (this.$store.state.slide.submited && this.$store.state.slide.openEndedMultipleOption || !this.$store.state.slide.openEndedMultipleOption)
          ) {
            this.confirmNextSlide()
            return
          }

          if (
            this.$store.state.slide.type === 'wordCloud' &&
            !this.$store.state.slide.openEndedMultipleOption &&
            this.$store.state.slide.openEndedSubmited
          ) {
            this.confirmNextSlide()
            return
          }
          if (
            this.$store.state.slide.type === 'multipleChoice' ||
            this.$store.state.slide.type === 'imageChoice' ||
            this.$store.state.slide.type === 'scale'
          ) {
            if (this.$store.state.slide.multipleChoiceStatus) {
              this.confirmNextSlide()
              this.$store.state.slide.radioSelectded = 1
            } else if (
              this.dataSlideNext &&
              this.$store.state.slide.id != this.dataSlideNext.id
            ) {
              this.showConfirmNext = true
            }

            return
          }
          if (this.$store.state.slide.deleted) {
            this.confirmNextSlide()
            return
          }
          if (!this.$store.state.slide.radioSelectded) {
            this.showConfirmNext = true
          } else {
            this.confirmNextSlide()
          }
        } else if (doc.action === 'stopSubmissionAction' || doc.action === 'bulletPointsIndexAction') {
          // Update dataSlideNext on start / stop submission
          if (!this.$store.state.slide.id || (this.$store.state.slide.id == doc.data.id)) {
            const url = doc.data.slideCacheUrl
            if (doc.action === 'bulletPointsIndexAction') {
              this.currentDataBulletPoint = doc.data
            }
            this.$http.get(url)
              .then((res) => {
                if (doc.action === 'bulletPointsIndexAction' && this.$store.state.slide.id != doc.data.id) {
                  return
                }
                if (doc.action === 'bulletPointsIndexAction' && this.currentDataBulletPoint.timestamp > doc.data.timestamp) {
                  return
                }
                const body = this.tryParseBody(res.bodyText, this.$store.state.presentation.id)
                const newSlideData = Util.formatSlide(body)
                this.$store.dispatch('updateSlide', this.compareSlides(newSlideData, this.$store.state.slide))
              })
              .catch((err) => {
                if (Sentry && err.status) {
                  err.from = 'Audience update current slide'
                  Sentry.captureException(JSON.stringify(err))
                }
              })
          } else if (this.dataSlideNext) {
            this.dataSlideNext = doc.data
          }
        } else if (doc.action === 'language') {
          this.$store.state.presentation.language =
            doc.data.presentation.language
          this.$store.dispatch('setLang', doc.data.presentation.language)
        } else if (doc.action === 'changeAccessCode') {
          this.$store.state.presentation.accessCode = doc.data.accessCode
        } else if (doc.action === 'audience-pacing') {
          SelfPacedQuiz.clearSelfPaceTimeouts()
          this.$store.state.presentation.audiencePacing =
            doc.data.presentation.audiencePacing
          if (this.$store.state.presentation.audiencePacing) {
            this.getSlideList(this.$store.state.presentation.id, true)
          } else {
            window.location.reload()
            this.$store.state.slide.isEndSlide = false
          }
          this.$store.dispatch('updateSlide', slide)
        } else if (doc.action === 'presenting') {
          this.$store.state.presentation.presenting =
            doc.data.presentation.presenting
          if (doc.data.presentation.presenting) {
            this.sendRequestUpdateTimeAudience()
          }
        } else if (doc.action === 'update') {
          this.$store.state.presentation.logo = doc.data.logo
          this.$store.state.logo = doc.data.logo
        } else if (doc.action === 'fontFamily') {
          this.$store.state.presentation.fontFamily =
            doc.data.presentation.fontFamily
          if (doc.data.presentation.fontFamily) {
            Util.setFontSlide(doc.data.presentation.fontFamily)
          }
        } else if (doc.action === 'qnaAnonymous') {
          this.$store.state.presentation.qnaAnonymous =
            doc.data.presentation.qnaAnonymous
        } else if (doc.action === 'qnaAllSlide') {
          this.$store.state.presentation.qnaAllSlide =
            doc.data.presentation.qnaAllSlide
        } else if (doc.action === 'qnaAudienceShowAll') {
          this.$store.state.presentation.qnaAudienceShowAll =
            doc.data.presentation.qnaAudienceShowAll
          this.handleDataQuestions(this.$store.state.presentation)
        } else if (doc.action === 'updateLogo') {
          this.$store.state.logo = doc.data.presentation.logo
        } else if (doc.action === 'showHyperLink') {
          this.$store.state.presentation.showHyperLink =
            doc.data.presentation.showHyperLink
        } else if (doc.action === 'privateMode') {
          SelfPacedQuiz.clearSelfPaceTimeouts()
          this.$store.state.presentation.privateMode =
            doc.data.presentation.privateMode
          if (!doc.data.presentation.privateMode) {
            if (doc.data.presentation.audiencePacing) {
              window.location.reload()
            } else {
              // Khi presenter mở public trở lại, thì cần count số participants cho đúng
              // Tuy nhiên, cần tránh việc tất cả audience cùng gọi 1 API tại 1 thời điểm
              setTimeout(() => {
                this.trackAudienceJoinPresentation(this.audienceId, doc.data.presentation.id)
              }, Math.random() * 10000)
            }
          }
        } else if (doc.action === 'notShowAhaSlidesLogo') {
          this.$store.state.presentation.notShowAhaSlidesLogo =
            doc.data.presentation.notShowAhaSlidesLogo
        } else if (doc.action === 'showAhaSlidesCTA') {
          this.$store.state.presentation.showAhaSlidesCTA =
            doc.data.presentation.showAhaSlidesCTA
        } else if (doc.action === 'hideIndividualLeaderboard') {
          this.$store.state.presentation.isHideIndividualLeaderboard = doc.data.presentation.isHideIndividualLeaderboard
        } else if (doc.action === 'presentation-update') {
          if (doc.data.teamPlay !== undefined) {
            this.$store.state.presentation.teamPlay = doc.data.teamPlay
            SelfPacedQuiz.playSelfPacedQuizSlide(this.$store.state.presentation, this.$store.state.slide)
          }
          if (doc.data.teamData !== undefined) {
            this.$store.state.presentation.teamData = doc.data.teamData
          }
          if (doc.data.teamSize !== undefined) {
            this.$store.state.presentation.teamSize = doc.data.teamSize
          }
          if (doc.data.teamCount !== undefined) {
            this.$store.state.presentation.teamCount = doc.data.teamCount
          }
          if (doc.data.teamScoringRule !== undefined) {
            this.$store.state.presentation.teamPlay = doc.data.teamScoringRule
          }
          if (doc.data.audienceAdmission !== undefined) {
            this._handleAudienceAdmissionDataFromSocket(doc.data)
          }
          if (doc.data.isEnableChat !== undefined) {
            this.$store.state.presentation.isEnableChat = doc.data.isEnableChat
          }
          if (doc.data.isEnablePrivateFeedback !== undefined) {
            this.$store.state.presentation.isEnablePrivateFeedback = doc.data.isEnablePrivateFeedback
          }
          if (doc.data.hideInstructionBar !== undefined) {
            this.$store.state.presentation.hideInstructionBar = doc.data.hideInstructionBar
          }
        } else if (doc.action === 'filteringProfanity') {
          this.$store.state.presentation.filteringProfanity = JSON.parse(doc.data)
        } else if (doc.action === 'updateLastSlide' && doc.data) {
          this.$store.state.slide.isEndSlide = false
          this.$store.state.presentation.lastSlide = doc.data
          this.$store.dispatch('updateSlide', this.$store.state.slide)
          this._checkSubmited()
        } else if (doc.action === 'enableModerationMode') {
          this.$store.state.presentation.isModerationMode = doc.data
          const arr = JSON.parse(JSON.stringify(this.$store.state.questions))
          Util.updateDataQuestionAnswer(
            arr,
            this.$store.state.tabQnaQuestion,
          )
        }
      } else if (doc.type === 'quiz-audience') {
        if (this.$store.state.presentation.audiencePacing) return

        sentry.addBreadcrumb({
          level: 'info',
          message: 'Socket message with type "quiz-audience"',
          data: {
            data: doc.data,
            quizTimestamp: doc.data.quizTimestamp,
          },
        })

        if (
          slide.type === 'pickAnswer'
          && this.$store.state.audienceName
          && this.$store.state.audienceEmoji
          && doc.action === 'startCountdownPickAnswer'
        ) {
          if (doc.data.quizTimestamp) {
            this.$store.state.slide.quizTimestamp = doc.data.quizTimestamp
          }

          this.$store.state.countdownTimeToAnswer = slide.timeToAnswer
          this.$store.state.slide.quizToken = doc.data.quizToken
          this.$store.state.slide.quizStatus = 4
          this.$store.dispatch('updateSlide', this.$store.state.slide)
          EventBus.$emit('start-countdown-pick-answer')
        }
      } else if (doc.type === 'audience-online') {
        if (this.$store.state.audienceName) {
          const data = {
            a: this.audienceId,
            c: this.$store.state.presentation.uniqueAccessCode,
          }
          if (this.$store.state.slide.type === 'pickAnswer' || this.$store.state.slide.type === 'spinnerWheel' || this.$store.state.slide.type === 'qrcode') {
            data.n = this.$store.state.audienceName
            data.e = this.$store.state.audienceEmoji
            data.t = this.$store.state.audienceQuizTeam
          }
          // eslint-disable-next-line promise/catch-or-return
          this.$http.post(Config.api.joinPresentation, data).then(
            () => {},
            () => {},
          )
        }
      } else if (doc.type == 'answer-quiz') {
        if (this.$store.state.slide.id == doc.data.id) {
          EventBus.$emit('answer-quiz', doc.data)
        }
      } else if (doc.type == 'question-and-answer') {
        if (doc.action == 'create') {
          if (this.audienceId == doc.data.audience) {
            doc.data.voted = true
            const arr = JSON.parse(JSON.stringify(this.$store.state.questions))
            arr.push(doc.data)
            Util.updateDataQuestionAnswer(
              arr,
              this.$store.state.tabQnaQuestion,
            )
          } else if (this.$store.state.presentation.qnaAudienceShowAll) {
            if (this.$store.state.tabQnaQuestion == 2) {
              this.$store.state.questions.unshift(doc.data)
            } else {
              this.$store.state.questions.push(doc.data)
            }
          }
        } else if (doc.action == 'vote' || doc.action === 'question-updated') {
          this._updateQuestionAnswer(doc.data)
        }
      } else if (doc.type == 'sort-slide') {
        this.isSortSlide = true
        setTimeout(() => {
          this.isSortSlide = false
        }, 500)
      } else if (doc.type == 'slideClearData') {
        setTimeout(() => {
          window.location.reload()
        }, 500)
      } else if (doc.type === 'slidePresentationData') {
        const { resetTimeStamp } = doc.data
        const presentationId = this.$store.state.presentation.id

        storage.clearValueByPresentation(presentationId)
        storage.setValueByPresentation(presentationId, 'resetTimeStamp', resetTimeStamp)
        this.clearChatMessagesAction({
          uniqueAccessCode: this.$store.state.presentation.uniqueAccessCode,
        })
        window.location.reload()
      } else if (doc.type === 'acceptTypeAnswer') {
        EventBus.$emit('acceptTypeAnswer', doc.data)
      } else if (doc.type === 'spinner-wheel') {
        if (doc.data) {
          if (!slide.metadata) this.$store.state.slide.metadata = {}
          this.$store.state.slide.metadata.wheelStatus = doc.data.wheelStatus
          if (doc.data.winner) {
            this.$store.state.slide.metadata.winner = doc.data.winner
          }
          this.$store.dispatch('updateSlide', this.$store.state.slide)
        }
      } else if (doc.type === 'change-voting-step') {
        if (!this.presentation.audiencePacing) {
          slide.votingStep = doc.data.votingStep
          this.$store.dispatch('updateSlide', this.$store.state.slide)
          EventBus.$emit('update-voting-step', doc.data.votingStep)
          if (doc.data.votingStep === 'result') {
            document.body.scrollIntoView()
          }
        }
      } else if (doc.type === 'create-idea') {
        slide.ideasCount = doc.data.ideasCount
        EventBus.$emit('create-idea', doc.data)
        this.$store.dispatch('updateSlide', this.$store.state.slide)
      } else if (doc.type === 'vote-idea') {
        EventBus.$emit('vote-idea', doc.data)
      } else if (doc.type === 'remove-idea') {
        EventBus.$emit('remove-idea', doc.data)
      } else if (doc.type === 'update-canvas-blocks') {
        EventBus.$emit('update-canvas-blocks', doc.data)
      } else if (doc.type === 'opentok') {
        if (doc.action === 'call-audience') {
          if (this.audienceId === doc.data.audienceUnique) {
            this.$store.state.presentation.token = doc.data.token
            this.$store.state.presentation.expiredToken = doc.data.expiredToken
            this.$store.state.presentation.session = doc.data.session
            this.$store.state.voiceCall = {
              isOpen: true,
              status: 'waiting-accept',
            }
          }
        }
        if (doc.action === 'stop-call') {
          this.$store.state.voiceCall = {
            isOpen: false,
          }
        }
      }
    },

    _updateQuestionAnswer(question) {
      const index = this.$store.state.questions.findIndex((item) => {
        return item.id == question.id
      })
      if (index === -1) {
        this.$store.state.questions.push(question)
      } else {
        this.$store.state.questions[index] = question
      }
      const arr = JSON.parse(JSON.stringify(this.$store.state.questions))
      Util.updateDataQuestionAnswer(arr, this.$store.state.tabQnaQuestion)
    },

    _clearDataSlide(slide) {
      const { resetTimeStamp, id: slideId, presentationId } = slide

      const alreadyClearedDataSlides = storage.getValueByPresentation(presentationId, 'alreadyClearedDataSlides', [])
      const matchSlide = alreadyClearedDataSlides.find((item) => item.slideId === slideId) || {}

      if (!resetTimeStamp || resetTimeStamp === matchSlide.resetTimeStamp) return

      // clear answered multiple choice questions
      const oldAnsweredSlideIds = storage.getValueByPresentation(presentationId, 'answeredSlideIds', [])
      const newAnsweredSlideIds = oldAnsweredSlideIds.filter((item) => slideId !== item)

      if (oldAnsweredSlideIds.length !== newAnsweredSlideIds.length) {
        storage.setValueByPresentation(presentationId, 'answeredSlideIds', newAnsweredSlideIds)
      }

      // update resetTimeStamp to storage for future checks
      const newAlreadyClearedDataSlides = alreadyClearedDataSlides.filter((item) => {
        return item.slideId !== slideId
      })
      newAlreadyClearedDataSlides.push({ slideId, resetTimeStamp })
      storage.setValueByPresentation(presentationId, 'alreadyClearedDataSlides', newAlreadyClearedDataSlides)

      // clear data multiplechoice & image choice by slide Id
      const answeredSlides = storage.getValueByPresentation(presentationId, 'answeredSlides', {})
      if (answeredSlides[slideId]) {
        delete answeredSlides[slideId]
        storage.setValueByPresentation(presentationId, 'answeredSlides', answeredSlides)
      }
    },

    // Don't change images when image name is not changed
    compareSlides(newData, oldData) {
      if (newData.image
        && oldData.image
        && newData.image.name === oldData.image.name
      ) {
        newData.image = oldData.image
      }

      if (newData.backgroundImage
        && oldData.backgroundImage
        && newData.backgroundImage.name === oldData.backgroundImage.name
      ) {
        newData.backgroundImage = oldData.backgroundImage
      }
      return newData
    },

    getSlideList(id, fromSocket) {
      this.$store.state.idSlide = null
      this.$store.state.slides = []
      this.$http.get(Config.api.listSlide + id).then(
        (res) => {
          this.$store.state.slides = res.body
          this.isLoading = false
          if (!fromSocket) {
            const currentSlideIndex = Util.getCurrentSlideIndexFromUrl()
            const isPresentationVisited = storage.getValueByPresentation(this.presentation.id, 'visited', false)
            // If slide index doesnt exist, or it's the very first time audience access this presentation
            // -> Redirect them to the first slide
            if (currentSlideIndex === 0 || !isPresentationVisited) {
              const path = `${window.location.pathname}#1`
              window.history.pushState({}, 'Live Audience Engagement Platform - AhaSlides', path)
            }

            if (!currentSlideIndex) {
              this.$store.state.idSlide = res.body[0].id
              this.confirmNextSlide()
            } else {
              this.checkAudiencePacing()
            }
          } else {
            this.$store.state.idSlide = JSON.parse(
              JSON.stringify(this.$store.state.slide.id),
            )

            const index = this.$store.state.slides.findIndex((item) => {
              return item.id == this.$store.state.idSlide
            })

            if (index !== -1) {
              const path = `${window.location.pathname}#${index + 1}`
              window.location.href = path
              window.location.reload()
            }
          }
          storage.setValueByPresentation(this.presentation.id, 'visited', true)
        },
        () => {},
      )
    },

    handleDataQuestions(doc) {
      if (doc) {
        const query = {
          isAudience: true,
          audience: this.audienceId,
          id: doc.id,
        }

        if (doc.qnaAudienceShowAll) {
          query.qnaAudienceShowAll = true
        }
        this.$http
          .get(Config.api.listQuestion, {
            params: query,
          })
          .then(
            (res) => {
              const arr = JSON.parse(JSON.stringify(res.body))
              Util.updateDataQuestionAnswer(
                arr,
                this.$store.state.tabQnaQuestion,
              )
            },
            () => {},
          )
      }
    },

    hideQASession() {
      this.$store.state.showQaSession = false
      Util.gaTrackEvent(
        'Question And Answer',
        'Audience',
        'Close Ask a question popup',
      )
    },

    hideFeedbackForm() {
      this.$store.state.showFeedbackForm = false
    },

    hideRequestPresentation() {
      this.$store.state.showRequestPresentation = false
      Util.gaTrackEvent(
        'Audience', 'Request presentation overlay > Click',
      )
    },

    _checkSubmited() {
      const { id, type } = this.$store.state.slide
      const presentationId = this.$store.state.presentation.id
      const answeredSlideIds = storage.getValueByPresentation(presentationId, 'answeredSlideIds', [])
      const lastSlideId = this.$store.state.presentation.lastSlide
      if (answeredSlideIds.includes(id)) {
        if (lastSlideId === id) {
          if (type === 'openEnded' || type === 'wordCloud') {
            if (!this.$store.state.slide.openEndedMultipleOption) {
              this.$store.state.slide.isEndSlide = true
              this.$store.dispatch('updateSlide', this.$store.state.slide)
            }
          } else if (type === 'multipleChoice' || type === 'imageChoice' || type === 'scale') {
            this.$store.state.slide.isEndSlide = true
            this.$store.dispatch('updateSlide', this.$store.state.slide)
          }
        }
      }
    },

    _handleAudienceAdmissionDataFromSocket(dataFromSocket) {
      const { presentation } = this.$store.state
      if (!presentation.audienceAdmission) presentation.audienceAdmission = {}
      presentation.disableFormJoinPresentation = false

      presentation.audienceAdmission.heading = dataFromSocket.audienceAdmission.heading

      presentation.audienceAdmission.isAudienceAdmission =
        dataFromSocket.audienceAdmission.isAudienceAdmission

      this._setPresentationAudienceAdmissionField(presentation,
        dataFromSocket.audienceAdmission.fields)
    },

    _setPresentationAudienceAdmissionField(presentation, fieldsFromSocket) {
      const hasFields = presentation.audienceAdmission && presentation.audienceAdmission.fields
      if (!hasFields) return
      const oldFields = [...presentation.audienceAdmission.fields]
      const oldFieldsHasText = oldFields.some((field) => field.data && field.data.length)
      presentation.audienceAdmission.fields = Util.formatFields(fieldsFromSocket)
      // If has value on input => keep that value
      if (oldFieldsHasText) {
        oldFields.forEach((oldField) => {
          const index = presentation.audienceAdmission.fields.findIndex(
            (field) => field.type === oldField.type,
          )
          if (index !== -1) {
            presentation.audienceAdmission.fields[index].data = oldField.data
          }
        })
      }
    },

    handleSlideOption: _.throttle(function throttleResultSlideOption(doc) {
      if (this.slide.id !== doc.slideId) return
      const { SlideOptions } = this.slide
      let totalVoteCount = 0
      SlideOptions.forEach((item) => {
        if (!item.votesCount) item.votesCount = 0
        const index = doc.slideOptions.findIndex((op) => {
          return op.id == item.id
        })
        if (index !== -1) {
          item.votesCount = doc.slideOptions[index].votesCount
        }
        totalVoteCount += item.votesCount
      })

      if (this.slide.showPercentage) {
        try {
          SlideOptions.forEach((item) => {
            item.votesCountValue = Number(`${Math.round(`${(item.votesCount / totalVoteCount) * 100}e1`)}e-1`)
          })
        } catch {
          SlideOptions.forEach((item) => {
            item.votesCountValue = item.votesCount
          })
        }
      } else {
        SlideOptions.forEach((item) => {
          item.votesCountValue = item.votesCount
        })
      }

      this.$store.dispatch('updateSlide', {
        SlideOptions,
      })
    }, 600),

    async sendRequestUpdateTimeAudience() {
      setTimeout(async () => {
        await this.$http.post(Config.api.updateTimeAudience, {
          presentationId: this.$store.state.presentation.id,
          audienceId: this.audienceId,
        })
      }, Math.random() * 30 * 1000)
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";

.qna-button-show {
  text-align: center;
  padding: 0 16px;
}

.overlay-qna {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.box-qna-session {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #00000050;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  z-index: 999;
  padding: 0 10px;
  padding-top: 140px;

  @media (max-width: 400px) {
    padding-left: 0;
    padding-right: 0;
  }
}

.box-request-presentation {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #00000050;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  z-index: 999;
  padding: 0 10px;

  @media (max-width: 400px) {
    padding-left: 0;
    padding-right: 0;
  }
}

.link-reload {
  cursor: pointer;
}

.waiting-next-slide {
  padding: 16px;
  text-align: center;

  .title {
    font-weight: bold;
    margin-top: 24px;
    margin-bottom: 8px;
  }

  .desp {
    color: #555;
    margin-bottom: 12px;
  }

  .fa-lg {
    font-size: 5.333333em;
    color: $primary-color;
  }
}

.loading-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;

  & ::v-deep .spinner {
    width: 210px;

    & > div {
      width: 30px;
      height: 30px;
    }
  }
}

.content-presentation {
  max-width: 710px;
  margin: 0 auto;
  padding: 0 0 24px 0;
  ::v-deep .text-hyper-link {
    color: inherit;
    text-decoration: underline;
    opacity: 0.8;
    word-break: break-all;
    &:hover {
      opacity: 1;
      text-decoration: underline !important;
      color: inherit !important;
    }
  }
  &.is-content-slide {
  max-width: 840px;

  }
}

.confirm-next-slide {
  position: fixed;
  top: -100%;
  left: 0;
  width: 100%;
  background-color: #fff;
  text-align: center;
  padding: 16px 0;
  transition: all 0.5s ease;
  border-bottom: 1px solid #ddd;
  z-index: 200;
  color: #313131;

  &.connection-lost {
    z-index: 300;
  }

  .text {
    margin-bottom: 10px;
    font-weight: bold;
  }

  button {
    margin: 0 5px;
  }

  &.active {
    top: 0;
  }
}

.no-data {
  padding: 16px;
}

.btn-signup {
  a {
    display: block;
    margin: 16px 0;
    text-decoration: none;
  }
}

.text-exit {
  color: $primary-color;
  cursor: pointer;
  &:hover {
    color: $primary-hover-color;
  }
}

.audience-pacing {
  text-align: center;
  font-size: 18px;
  margin-top: 16px;
  padding: 0 16px;

  a {
    cursor: pointer;
  }
}

.presentation {
  &.white {
    & ::v-deep .default-logo {
      display: none;
    }
    & ::v-deep .white-logo {
      display: block;
    }

    & ::v-deep .footer {
      a {
        color: #fff;
        text-decoration: underline;
      }
    }

    & ::v-deep .input-wrapper {
      background-color: #00000040;
    }

    & ::v-deep .text-exit {
      color: #fff;
      text-decoration: underline;
    }

    & .audience-pacing {
      a {
        color: #fff;
        text-decoration: underline;
      }
    }

    & ::v-deep .change-team {
      color: #fff;
    }
  }

  & ::v-deep .content-bulletpoint {
    .audio-control-slide {
      text-align: center;
    }
  }
}

.slide-text-left {
  & ::v-deep {
    .slide-title-style, .title-desc, .subheading-bulletPoints, .no-result-yet-text, .subheading, .bullet-list-item {
      text-align: left;
    }
    .audio-control-slide {
      text-align: left !important;
    }

    .fix-content-leaderboard {
      text-align: left;
    }
  }
}

.slide-text-right {
  & ::v-deep {
    .slide-title-style, .title-desc, .subheading-bulletPoints, .no-result-yet-text, .subheading, .bullet-list-item {
      text-align: right;
    }
    .audio-control-slide {
      text-align: right !important;
    }
    .bullet-list-item {
      direction: rtl;
    }
    .fix-content-leaderboard {
      text-align: right;
    }
  }
}

.slide-text-center {
  & ::v-deep {
    .slide-title-style, .title-desc, .subheading-bulletPoints, .no-result-yet-text, .subheading {
      text-align: center;
    }
    .audio-control-slide {
      text-align: center !important;
    }
  }
}
.try-to-reload {
  display: flex;
  justify-content: center;
  margin: 16px 0;
  .link-reload {
    margin: 0 0 0 0.25rem;
  }
}

</style>
